import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

const state = { boards: [], tasks: [], uiFlags: { isFetching: false } };

export default { namespaced: true, state, actions, mutations, getters };
